import * as types from "../types/wallet"
import { getServiceOwnerWallet } from "services"

export const fetchWalletDetails = () => (
  async (dispatch) => {
    try {
      const response = await getServiceOwnerWallet()

      const balance =
        Number(response.balance)

      dispatch({
        type: types.FETCH_WALLET_DETAILS,
        wallet: { balance }
      })
    } catch (err) {
      console.log(err)
    }
  }
)

export const clearWalletDetails = () => ({
  type: types.CLEAR_WALLET_DETAILS
})